import {
  executeCallsSession,
  type CallsSessionExecution,
  type CallsSessionExecutionResult,
} from './CallsSessionExecutionEngine';

export type CallsRuntimeBridgeStatus =
  | 'authorized'
  | 'denied';

export interface CallsRuntimeBridgeResult {
  readonly governor: string;
  readonly governorId: string;
  readonly governorKey: string;
  readonly domain: string;
  readonly lifecycle: string;
  readonly evidenceSource: 'calls-runtime-bridge';
  readonly upstreamEvidenceSource:
    CallsSessionExecutionResult['evidenceSource'];
  readonly execution: CallsSessionExecution;
  readonly executionAuthorized: boolean;
  readonly status: CallsRuntimeBridgeStatus;
  readonly decision:
    CallsSessionExecutionResult['decision'];
  readonly reasonCode: string;
  readonly reason: string;
  readonly evidenceCapturedAt: string;
}

function mapRuntimeBridgeStatus(
  execution: CallsSessionExecution,
): CallsRuntimeBridgeStatus {
  return execution === 'execute'
    ? 'authorized'
    : 'denied';
}

export function bridgeCallsRuntime():
  CallsRuntimeBridgeResult {
  const authorization = executeCallsSession();

  const executionAuthorized =
    authorization.execution === 'execute';

  return Object.freeze({
    governor: authorization.governor,
    governorId: authorization.governorId,
    governorKey: authorization.governorKey,
    domain: authorization.domain,
    lifecycle: authorization.lifecycle,
    evidenceSource: 'calls-runtime-bridge',
    upstreamEvidenceSource:
      authorization.evidenceSource,
    execution: authorization.execution,
    executionAuthorized,
    status: mapRuntimeBridgeStatus(
      authorization.execution,
    ),
    decision: authorization.decision,
    reasonCode: authorization.reasonCode,
    reason: authorization.reason,
    evidenceCapturedAt:
      authorization.evidenceCapturedAt,
  });
}
